import axios from 'axios';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS,
  REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD,
  FETCH_PURCHASING_PERFORMANCE_FAILURE,
} from './type';

import {
  PURCHASE_URL,
} from './url';
import { isGGI, isLAP, isUSPrideMulti, isAPD } from './root_url'

export function fetchPurchasePerformanceByFilter(days, fromDate, toDate, type, POStatus, Vendor_id, ProductNum, orderTypeParams) {
  const dates = toFromDates(days, fromDate, toDate);
  let searchBy;
  if (Vendor_id) {
    Vendor_id = Vendor_id.value || Vendor_id;
    if (isLAP || isUSPrideMulti || isAPD) {
      searchBy = `Vendor`
      Vendor_id = `&vendor_id=${Vendor_id}`
    } else {
      searchBy = `Vendor_id/${Vendor_id}/`;
      Vendor_id = ''
    }
  } else if ((isLAP || isUSPrideMulti || isAPD) && !Vendor_id && !ProductNum) {
    searchBy = 'Vendor/'
  }else {
    searchBy = `ProductNum/${ProductNum}/`;
  }
  if (POStatus) {
    POStatus = POStatus.value || POStatus;
    POStatus = `&PurchaseStatus=${POStatus}`;
  } else {
    POStatus = '&PurchaseStatus=All';
  }
  return (dispatch) => {
    dispatch({
      type: REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
      payload: {
        Vendor_id,
        dates,
        POStatus,
        searchBy,
        orderTypeParams,
      },
    });
  };
}

export const PurchasingPerformanceListEpic = action$ =>
  action$.ofType(REQUEST_PURCHASING_PERFORMANCE_BY_FILTER)
    .switchMap(action =>
      axios.get(
        `${PURCHASE_URL}performance/${action.payload.searchBy}?OrderDate__gte=${action.payload.dates.fromDate}&OrderDate__lte=${action.payload.dates.toDate}${action.payload.POStatus}${action.payload.Vendor_id || ''}`,
        {
          params: {
            ...action.payload.orderTypeParams,
          },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_PURCHASING_PERFORMANCE_SUCCESS, payload: response }))
    .catch((err, source) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.data) {
        alert(JSON.stringify(err.data));
      } else {
        alert(JSON.stringify(err));
      }
      return source;
    });

export function fetchPurchasePerformanceByFilterGFD(days, fromDate, toDate, type, POStatus, Vendor_id, ProductNum, orderTypeParams) {
  const dates = toFromDates(days, fromDate, toDate);
  if (Vendor_id) {
    Vendor_id = Vendor_id.value || Vendor_id;
    Vendor_id = `&vendor_id=${Vendor_id}`
  } else {
    Vendor_id = ''
  }
  if (POStatus) {
    POStatus = POStatus.value || POStatus;
    POStatus = `&order_type=${POStatus}`;
  } else {
    POStatus = '&order_type=All';
  }

  return (dispatch) => {
    dispatch({
      type: REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD,
      payload: {
        Vendor_id,
        dates,
        POStatus,
        orderTypeParams,
      },
    });
  };
}

export const PurchasingPerformanceListEpicGFD = action$ =>
  action$.ofType(REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD)
    .switchMap(action => {
      return axios.get(
        `${PURCHASE_URL}new_performance/?start_date=${action.payload.dates.fromDate}&end_date=${action.payload.dates.toDate}${action.payload.Vendor_id}${action.payload.POStatus}`,
        {
          params: {
            ...(action.payload.orderTypeParams || {}),
          },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )})
    .map(response => {
      return ({ type: FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD, payload: response })})
    .catch((err, source) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
        return
      }
      if (err.data) {
        alert(JSON.stringify(err.data));
      } else {
        alert(JSON.stringify(err));
      }
      return source;
    });


// WEBPACK FOOTER //
// ./master/jsx/actions/purchasingPerformanceList_actions.js